<template>
  <!--Icon-->
  <div
    class="d-inline-block c-pointer c-black btn btn-outline-orange w-150px"
    v-clipboard:copy="urlSite"
    v-clipboard:success="onCopy"
    v-clipboard:error="onError"
    title="Copiar a URL do assunto"
  > 
    <!--Text-->
    <i class="fas fa-link fs-25 mr-2"></i>
    Copiar Link
  </div>
</template>

<script>
import makeToast from '../../mixins/makeToast';

export default {
  data: () => ({
    //urlSite: window.location.href,
    urlSite: document.URL,
  }),
  mixins: [makeToast],
  methods: {
    copyLink() {
      const copyText = this.urlSite;
      copyText.select();
      document.execCommand('copy');
      this.makeToast('Sucesso', 'Copiado com sucesso!', 'success');
    },
    onCopy() {
      this.makeToast(
        'Sucesso',
        'Link do assunto copiado com sucesso!',
        'success'
      );
      const copyText = this.urlSite;
      copyText.select();
      document.execCommand('copy');
    },
    onError() {
      this.makeToast('Oopss', 'Link do assunto não foi copiado!', 'danger');
    },
  },
};
</script>
